import SubmitForm from "@/components/feature/SubmitForm";
import { siteInfo } from "@/mocks/articles";

const points = [
  { icon: "ri-eye-line", text: "只关注可核实的事实，不放大情绪化表述" },
  { icon: "ri-lock-line", text: "投稿人信息严格保密，不做公开处理" },
  { icon: "ri-refresh-line", text: "结论有误时公开更正，并保留时间线" },
];

export default function SubmitSection() {
  return (
    <section id="submit" className="w-full scroll-mt-24">
      <div className="grid gap-8 lg:grid-cols-5">
        <div className="col-span-1 lg:col-span-2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-500 text-primary-800">
            <i className="ri-send-plane-line"></i>
            线索与订阅
          </span>
          <h2 className="mt-4 font-heading text-2xl font-700 text-foreground-950 md:text-3xl">把线索交给我们核实</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            看到拿不准的传言、收到可疑的截图，或想补充某条爆料的后续进展，都可以直接提交。核实组会逐条查看并回复。
          </p>

          <ul className="mt-6 space-y-4">
            {points.map((p) => (
              <li key={p.text} className="flex items-start gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <span className="pt-1 text-sm leading-relaxed text-foreground-700">{p.text}</span>
              </li>
            ))}
          </ul>

          <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4">
            <p className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-600"></i>
              也可直接发送至 {siteInfo.submitEmail}
            </p>
          </div>
        </div>

        <div className="col-span-1 lg:col-span-3">
          <SubmitForm />
        </div>
      </div>
    </section>
  );
}